import {
  DialogPositionStrategyInIframe,
  ENVIRONMENTS,
  RETAILERS,
} from '@shared/constants';
import { Environment } from '@shared/models';

import '@angular/common/locales/global/fr';

export const environment: Environment = {
  lang: 'fr-FR',
  maxReward: 50,
  production: true,
  maintenance: false,
  hasCampaignBis: true,
  hasBisPage: true,
  baseHref: '/fr/',
  maxSelectedChallenges: 10,
  env: ENVIRONMENTS.STAGING,
  projectType: 'loyaltyChallenge',
  retailerName: RETAILERS.CHONDRUS,
  reCAPTCHAKey: '6LcXSVYoAAAAAH1hxFXD7QoM21vbKp8fX0eGOkvr',
  backendUrl: 'https://b2c.parcours-gagnants.ai.eagleeye.com/api/v2',
  dialogPositionStrategyInIframe: DialogPositionStrategyInIframe.DEFAULT,
  enableSentry: true,
  ssrAllowedHosts: ['*.uat.ai.eagleeye.com'],
};
